import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const RootProviders = lazy(() => import('@app/components/AppProviders'))
const NewVersionNotification = lazy(() => import('.'))

class NewVersionNotificationWebComponent extends ReactWebComponent {
	static get observedAttributes() {
		return ['lokalise-version']
	}

	override render() {
		const lokaliseVersion = this.getAttribute('lokalise-version')

		return (
			<RootProviders>
				<NewVersionNotification lokaliseVersion={lokaliseVersion} />
			</RootProviders>
		)
	}
}

customElements.define('new-version-notification', NewVersionNotificationWebComponent)
